import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 23E8809B-FB62-4573-83CF-9C33E980FD41
 * name battery-charging-60
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-60.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Automotive 
 */
export const BatteryCharging60Icon = createSvgIcon(<><path d="M12,11H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4M23,11H20V4L15,14H18V22L23,11Z" /></>, 'BatteryCharging60Icon');
export default BatteryCharging60Icon